export default __webpack_public_path__ + "static/media/homecare_patient_alarm.64b492a7.wav";